import { Component, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { BaseComponent } from '../../../../shared/base-components/base.component';
import { BusinessTransactionService } from '../../../../shared/services/business-transaction/business-transaction.service';
import { TransactionService } from '../../../services/transaction.service';
import { NMVTISMessageModel } from '../../models/nmvtis-message.model';

@Component({
    selector: 'error-message',
    templateUrl: './error-message.html',
    inputs: ['nmvtisMessageModel'],
    outputs: ['onCancel']
})
// should be called in case of all the warnings and not just vehicle-not-found
export class ErrorMessageComponent extends BaseComponent {

    public dataLoaded = false;
    public message: string;
    private businessTransactionNumber: number;

    // public onSaved: EventEmitter<boolean> = new EventEmitter<boolean>();
    public onCancel: EventEmitter<boolean> = new EventEmitter<boolean>();
    public nmvtisMessageModel: NMVTISMessageModel;

    constructor(private _businessTransactionService: BusinessTransactionService,
        private _transactionService: TransactionService,
        private _router: Router,
        private _route: ActivatedRoute) {

        super();
        this.businessTransactionNumber = +_route.snapshot.params['id']; // grab the business transaction from the route.

    }

    ngOnInit() {
        // this.message = "The vehicle was not found on NMVTIS.";
        this.message = this.nmvtisMessageModel.interactionManagerMessageContent;
        this.dataLoaded = true;
    }

    onCancelClick() {
        this.onCancel.emit(true);
    }
    // onSaveClick() {
    //    this.onSaved.emit(true);
    // }
    async onAbortTransactionClick() {
        await this._businessTransactionService.expireBusinessTransaction(this.businessTransactionNumber.toString());
        this.onCancelClick(); // close the modal first
        // navigate to the check-in screen and prepopulate with customer data. Make sure customer and agent are same for this purpose.
        const businessTransactionMetaData = (await this._businessTransactionService.getTransactionMetaData(this.businessTransactionNumber.toString()).pipe(first()).toPromise());
        this._router.navigate(['/transaction/agent', businessTransactionMetaData.agentId, { outlets: { 'body': ['serviceslist', businessTransactionMetaData.agentId], 'sidebar': ['servicesadd', businessTransactionMetaData.agentId], 'head': ['info', businessTransactionMetaData.agentId] } }]);
    }
}
